import { createSlice } from "@reduxjs/toolkit";
import { RoleData, RoleInitialStatus } from "../../../../types/csoManager/role";
import { createRoleAsync, getAllRoleListAsync } from "./roleApi";

const initialState: RoleInitialStatus<RoleData> = {
  loading: false,
  manageLoading: false,
  roleList: [],
  countRole: 0,
};

const csoRoleSlice = createSlice({
  name: "admin-csoRole",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createRoleAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createRoleAsync.fulfilled, (state) => {
        state.manageLoading = true;
      })
      .addCase(createRoleAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllRoleListAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllRoleListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.roleList = action.payload.data;
        state.countRole = action.payload.length;
      })
      .addCase(getAllRoleListAsync.rejected, (state) => {
        state.loading = false;
        state.roleList = [];
        state.countRole = 0;
      });
  },
});

export default csoRoleSlice;
